import Box from 'reusecore/src/elements/Box';
import ListGrid from 'reusecore/src/elements/ListGrid';

import { CURRENCY } from '../../../Config';
import CardLoader from '../../../components/Loader/CardLoader';
import PostCard from '../../../components/PostCard';

const RelatedPost = props => {
  const { limit, loading, related: relatedItem = [] } = props;

  const renderRelatedPost = item => {
    const {
      additionalType = '',
      category = '',
      id: itemId = '',
      media: images = [],
      photos = [],
      price = null,
      sid,
      title = '',
      town = '',
      updatedAt = '',
    } = item;

    const checkPrice = price > 0 ? price : null;

    return (
      <PostCard
        currency={CURRENCY}
        additionalType={additionalType}
        title={title}
        price={checkPrice}
        id={itemId}
        sid={sid}
        category={category}
        town={town}
        createdAt={updatedAt}
        imageSrc={images}
        photos={photos}
        hn="h3"
      />
    );
  };

  return (
    <Box mt={30} width={1}>
      <ListGrid
        data={relatedItem}
        columnWidth={[1, 1 / 2, 1 / 3, 1 / 4]}
        limit={limit}
        component={renderRelatedPost}
        loading={loading}
        placeholder={<CardLoader />}
      />
    </Box>
  );
};

export default RelatedPost;
